export default "__VITE_ASSET__C13DJ5pF__"